module.exports = __webpack_public_path__ + "img/card-dark-edge.8a52be9c.svg";